module.exports = __webpack_public_path__ + "static/media/thierry-mugler-angel.4b6af123.png";